<template>
    <modal :class="{'is-active':isActive}" :onClose="() => {}">
        <header slot="header" class="modal-card-head has-text-centered">
            <p class="modal-card-title">Link</p>
            <button class="delete" aria-label="close" @click="close()"></button>
        </header>
        <section slot="content" class="modal-card-body">
            <!-- name -->
            <div class="field is-horizontal link-field">
                <div class="field-label is-small">
                    <label class="label">Name</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input v-model="link.name" class="input is-small" type="text" />
                        </p>
                    </div>
                </div>
            </div>
            <!-- url -->
            <div class="field is-horizontal link-field">
                <div class="field-label is-small">
                    <label class="label">Url</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input v-model="link.url" class="input is-small" type="text" />
                        </p>
                    </div>
                </div>
            </div>
            <!-- image -->
            <div class="field is-horizontal link-field">
                <div class="field-label is-small">
                    <label class="label">Image</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <input v-model="link.image" class="input is-small" type="text" />
                        </p>
                    </div>
                </div>
            </div>
            <!-- translations -->
            <div class="field is-horizontal link-field">
                <div class="field-label is-small">
                    <label class="label">Translations</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <p class="control">
                            <table class="table is-hoverable">
                                <tr v-for="lang in languages" :key="lang">
                                    <td><span class="is-size-7">{{lang}}</span></td>
                                    <td><input v-model="link.translations[lang]" class="input is-small" type="text" /></td>
                                </tr>
                            </table>
                        </p>
                    </div>
                </div>
            </div>

            <div class="field has-text-centered">
                <button
                    slot="footer"
                    class="button"
                    @click="close()"
                >OK</button>
            </div>
        </section>
    </modal>
</template>
<script>
import Modal from '../../modal.vue';

export default {
    name: 'content-link-edit-modal',
    components: { Modal },
    data() {
        return {
            languages: ['en', 'es', 'fr', 'he', 'ru'],
            isActive: false,
            link: {
                translations: {}
            }
        };
    },
    methods: {
        open(l) {
            l.translations = l.translations || {};
            this.languages.forEach(lang => l.translations[lang] = l.translations[lang] || '');
            this.link = l;
            this.isActive = true;
        },
        close() {
            this.isActive = false;
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/components/common/content/link/link-edit-modal.vue